<template> <!-- HeaderSection-->

<!-- Mission Section -->
<section class="container py-5">
    <div class="row align-items-center">
        <div class="col-lg-6">
            <h2 class="display-5">Our Mission</h2>
            <p class="lead text-start">At the core of our mission is the commitment to guiding our community through the sacred process of drafting a wasiyah (will). This important document not only fulfills a religious obligation but also reflects one’s personal values and priorities. We aim to provide clarity and peace of mind by ensuring that your wishes regarding the distribution of your wealth and responsibilities are expressed in accordance with Islamic principles. By doing so, we help prevent disputes among family members and protect the rights of your heirs, ensuring fair asset distribution and upholding Islamic inheritance laws.
            </p>
            <p>Our services are completely free, enabling everyone to build their wasiyah without any cost. We are dedicated to making this important process accessible to all.</p>
        </div>
        <div class="col-lg-6">
            <img src="../../../assets/images/family.jpg" class="img-fluid rounded" alt="Mission Image">
        </div>
    </div>
</section>

<!-- Team Section -->
<section class="bg-light py-5">
    <div class="container text-center">
        <h2 class="display-5">Meet Our Team</h2>
        <p class="mb-5">Our team is passionate about travel and dedicated to providing exceptional service.</p>
        <div class="row"> 
        <div class="col-md-4 mb-4" v-for="member in teamMembers" :key="member.id"> 
        <div class="card border-0 shadow"> 
        <img :src="require(`@/assets/images/${member.image}`)" class="card-img-top rounded-circle p-4" :alt="member.name"> 
        <div class="card-body"> <h5 class="card-title">{{ member.name }}</h5> 
        <p class="card-text">{{ member.role }}</p> <p class="text-muted">{{ member.description }}</p> 
        </div> 
        </div> 
        </div> 
        </div>
    </div>
</section>

<!-- Call to Action Section -->
<section class="bg-primary text-white text-center py-5">
    <div class="container">
        <h2 class="display-5">{{ $t('next adventure') }}</h2>
        <p class="lead">{{ $t('lead-value') }}</p>
        <a href="contact-us" class="btn btn-light btn-lg mt-3">{{ $t('Contact Us') }}</a>
    </div>
</section>
</template>

<script> 
export default { 
  data() { 
    return { 
      teamMembers: [ 
      { id: 1, name: 'FAHAD BIN BADIUL ALAM', role: 'Managing Director', description: 'Fahad Bin Badiul Alam leads with passion and commitment, ensuring top-notch service for all clients.', image: 'fahad-vai-image.jpeg' }, 
{ id: 2, name: 'MD.YEASIN FOISAL', role: 'Business Development Strategist', description: 'Yeasin Emily ensures smooth operations, making every journey seamless and enjoyable.', image: 'MarketingManager.jpeg' }, 
{ id: 3, name: 'Nur Islam Rajib', role: 'App Developer', description: 'Rajib brings creativity to our campaigns, helping us reach and inspire more travelers with this.', image: 'rajib.jpg' }, 
{ id: 4, name: 'Shahid Ullah Bahar', role: 'Software Developer', description: 'Bahar brings creativity to our campaigns, helping us reach and inspire more travelers with this.', image: 'Bahar.jpg' }, 
{ id: 5, name: 'Safayet Hossain', role: 'UI/UX Designer', description: 'Safayet brings creativity to our campaigns, helping us reach and inspire more travelers with this.', image: 'Safayet.jpg' } ] }; } }; </script>